import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgDotsVertical = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.2 2.66667C9.2 3.32942 8.66274 3.86667 8 3.86667C7.33726 3.86667 6.8 3.32942 6.8 2.66667C6.8 2.00393 7.33726 1.46667 8 1.46667C8.66274 1.46667 9.2 2.00393 9.2 2.66667ZM9.2 8.00001C9.2 8.66275 8.66274 9.20001 8 9.20001C7.33726 9.20001 6.8 8.66275 6.8 8.00001C6.8 7.33727 7.33726 6.80001 8 6.80001C8.66274 6.80001 9.2 7.33727 9.2 8.00001ZM8 14.5333C8.66274 14.5333 9.2 13.9961 9.2 13.3333C9.2 12.6706 8.66274 12.1333 8 12.1333C7.33726 12.1333 6.8 12.6706 6.8 13.3333C6.8 13.9961 7.33726 14.5333 8 14.5333Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgDotsVertical)
const IconSvgDotsVertical = createIcon(ForwardRef, 'SvgDotsVertical')
export default IconSvgDotsVertical
